import * as React from "react";

import { AnsweredQuestionWithId } from "@teamprevent/common/model";

import { Action } from "redux";

import { clearQuestionnaire, submitInvalidQuestionnaire } from "@teamprevent/common/questionnaires/actions";

import { ThunkDispatch } from "redux-thunk";

import { connect } from "react-redux";

import { goToParent } from "@teamprevent/common/routing";

import { AddTaskForm } from "../../tasks/components/addTaskForm";
import { AddTaskFormModel, TaskType } from "../../task/model";
import { ApplicationState } from "../../applicationState";
import { routeIdSelector as customerIdSelector } from "../../crud/customer/selectors";
import { routeIdSelector as ohCaseIdSelector } from "../../crud/ohCase/selectors";
import { taskIdSelector } from "../../task/selectors";
import { getUserSortableName } from "../../crud/adminUser/model";
import { AdminUserListModelWithTeams, AppState as AdminUserListModelWithTeamsState } from "../../crud/adminUserWithTeams/model";
import { loadAdminUsersWithTeams as loadAdminUsersAction } from "../../crud/adminUserWithTeams";
import { adminUsersWithTeamsSelector } from "../../crud/adminUserWithTeams/selectors";

import { submitBbvClinicalNotes } from "../../clinicalNotes/actions";

import { loadBbvReportSuccessorTasks } from "../../bbvReport/actions";

import { QUESTIONNAIRE_KEY, VaccinationConsultationNotes } from "./VaccinationConsultationNotes";

interface StateProps {
    ohCaseId: string;
    taskId: string;
    customerId: string;
    successorTaskTypes: TaskType[];
    adminUsersWithTeams: AdminUserListModelWithTeams[];
}

interface DispatchProps {
    submitQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[], task: AddTaskFormModel) => void;
    submitInvalidQuestionnaire: () => void;
    navigateBack: () => void;
    loadAdminUsers: () => void;
    clearQuestionnaire: () => void;
    loadBbvReportSuccessorTasks: () => void;
}

type Props = StateProps & DispatchProps;

interface State {
    submitted: boolean;
    task: AddTaskFormModel;
    isValid: boolean;
}

class BbvVaccinationConsultationUnconnected extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.props.clearQuestionnaire();
        this.props.loadBbvReportSuccessorTasks();

        if (!this.props.adminUsersWithTeams?.length) {
            this.props.loadAdminUsers();
        }
    }

    public state: State = { submitted: false, isValid: false, task: { dueDate: null, taskType: null, taskCode: null, notes: "" } };

    private getAdminUserOptions() {
        if (!this.props.adminUsersWithTeams?.length) {
            return [];
        }

        const adminUsersWithTeams = [...this.props.adminUsersWithTeams.sort((a, b) => getUserSortableName(a).localeCompare(getUserSortableName(b)))];

        adminUsersWithTeams.splice(0, 0, { id: "Unassigned", emailAddress: "Unassigned" });

        return adminUsersWithTeams;
    }

    public render = () => {
        const taskSection = (
            <AddTaskForm
                defaultDueDate
                ohCaseId={this.props.ohCaseId}
                onChange={this.onChangeTask}
                showErrors={this.state.submitted}
                task={this.state.task}
                taskTypes={this.props.successorTaskTypes}
                adminUsers={this.getAdminUserOptions()}
                assignmentOptionRequired={true}
            />
        );
        return (
            <VaccinationConsultationNotes
                submitQuestionnaire={this.submitQuestionnaire}
                tasksSection={taskSection}
                tasksSectionValid={!!this.state.isValid}
            />
        );
    };

    private onChangeTask = (task: AddTaskFormModel, isValid: boolean) => {
        this.setState({ task, isValid });
    };

    private submitQuestionnaire = async (questions: AnsweredQuestionWithId[]) => {
        if (!this.state.isValid) {
            this.props.submitInvalidQuestionnaire();
            return;
        }

        await this.props.submitQuestionnaire(this.props.ohCaseId, this.props.taskId, this.props.customerId, questions, this.state.task);
        this.props.navigateBack();
    };
}

const mapStateToProps = (state: ApplicationState & AdminUserListModelWithTeamsState): StateProps => ({
    customerId: customerIdSelector(state),
    ohCaseId: ohCaseIdSelector(state),
    taskId: taskIdSelector(state),
    successorTaskTypes: state.bbvReportSuccessorTasks,
    adminUsersWithTeams: adminUsersWithTeamsSelector(state)
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ApplicationState, void, Action>): DispatchProps => ({
    navigateBack: () => dispatch(goToParent()),
    submitInvalidQuestionnaire: () => dispatch(submitInvalidQuestionnaire(QUESTIONNAIRE_KEY)),
    submitQuestionnaire: (ohCaseId: string, taskId: string, customerId: string, questions: AnsweredQuestionWithId[], task: AddTaskFormModel) => {
        dispatch(submitBbvClinicalNotes(ohCaseId, taskId, customerId, questions, QUESTIONNAIRE_KEY, task));
    },
    loadAdminUsers: () => dispatch(loadAdminUsersAction()),
    clearQuestionnaire: () => dispatch(clearQuestionnaire(QUESTIONNAIRE_KEY)),
    loadBbvReportSuccessorTasks: () => dispatch(loadBbvReportSuccessorTasks())
});

export const BbvVaccinationConsultationNotes = connect(mapStateToProps, mapDispatchToProps)(BbvVaccinationConsultationUnconnected);
